import React, { useEffect, useRef, useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { Avatar, Box, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Chip } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";
import {
  GET_ALL_RESOURCES,
  UPDATE_USER_PASSWORD,
  USER_REGISTRATION,
  UPDATE_RESOURCES_EMAIL_STATUS,
  SEND_RESOURCES_EMAIL,
} from "../../constants/endpoints";
import AxiosServiceLoaderless from "../../constants/api";
import SearchForm from "../../components/SearchForm/SearchForm";
import PaginationFooter from "../../components/PaginationFooter/PaginationFooter";
import UsersCsv from "../../components/csv/UsersCsv";
import { CSVLink } from "react-csv";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import AxiosService from "../../constants/api";
import { toast } from "react-toastify";
import Checkbox from "@material-ui/core/Checkbox";

//let SEND_RESOURCES_EMAIL ="SendEmail"

const useStyles = makeStyles((theme) => ({
  searchWrapper: {
    flex: "1 1 0%",
    boxSizing: "border-box",
  },
  searchForm: {
    background: "white",
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(1) * 2,
    display: "block",
    maxWidth: "800px",
  },
  searchInput: {
    fontSize: "1rem",
    padding: theme.spacing(1) * 1.9,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1) * 1.2,
    },
    cursor: "text",
    textIndent: "30px",
    border: "none",
    background: "transparent",
    width: "100%",
    outline: "0",
  },
  searchIcon: {
    position: "absolute",
    top: "50%",
    left: "0",
    marginTop: "-24px",
    color: "rgba(0,0,0,.87)",
  },
  selectedCount: {
    marginLeft: theme.spacing(2),
    display: "inline-flex",
    alignItems: "center",
  },
  emailChip: {
    margin: theme.spacing(0.5),
  },
  sendEmailButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(2),
  },
  disabledButton: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
}));

const styles = (theme) => ({
  root: {
    margin: theme.spacing(1),
    overflowX: "auto",
  },
  subroot: {
    margin: theme.spacing(2),
    overflowX: "auto",
  },
  tableContainer: {
    maxHeight: "55vh", // Set the maximum height for the table body
    overflowY: "auto", // Enable vertical scrolling
  },
  table: {
    // marginRight:"20px"
  },
  title: {
    flex: "0 0 auto",
    padding: "20px",
  },
  avatar: {
    margin: 10,
  },
  bigAvatar: {
    width: 60,
    height: 60,
  },
  pagination: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
  },
  loadingCell: {
    textAlign: "center",
    padding: theme.spacing(2),
  },
  sendEmailButton: {
    marginLeft: theme.spacing(2),
  },
});

const limit = parseInt(process.env.REACT_APP_TABLE_ROW_LIMIT) || 100;

const ActiveResources = ({ classes }) => {
  const history = useHistory();
  const searchClasses = useStyles();
  const auth = JSON.parse(localStorage.getItem("auth"));

  const [fields, setFields] = useState([
    {
      name: "comp_id",
      label: "Company",
      type: "select",
      required: false,
      options: [],
    },
    {
      name: "emp_id",
      label: "Employee",
      type: "select",
      required: false,
      options: [],
    },
    {
      name: "is_email_send",
      label: "Email Status",
      type: "select",
      required: false,
      options: [
        { value: "0", label: "Not Sent" },
        { value: "1", label: "Sent" },
      ],
    },
    {
      name: "from",
      label: "From",
      required: false,
      type: "date",
    },
    {
      name: "to",
      label: "To",
      required: false,
      type: "date",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentHoveredImage, setCurrentHoveredImage] = useState(null);
  const [hoverImage, setHoverImage] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [data, setData] = useState({
    rows: [],
    currentPage: 1,
    nextOffset: 0,
    lastOffset: 0,
    limit: limit,
    totalPages: 0,
  });
  const [csvData, setCsvData] = useState({ headers: [], data: [] });
  const [searchFields, setSearchFields] = useState(null);
  const csvLink = useRef(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [selectedResources, setSelectedResources] = useState({});
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [emailList, setEmailList] = useState([]);

  // Handle form submission
  const handleSubmit = async (row, popupState) => {
    if (!password || !row.user_id || !row.api_key) {
      return;
    }

    const data = {
      user_id: row.user_id,
      api_key: row.api_key,
      password: password,
    };
    try {
      const res = await AxiosService.post(UPDATE_USER_PASSWORD, data);
      if (res.status === 200) {
        popupState.close();
        toast.success("Password updated successfully.");
      }
    } catch (error) {
      toast.error(error.response);
      console.log("Error", error);
    }
  };

  // Handle checkbox change
  const handleCheckboxChange = async (row, checked) => {
    // Update selected resources
    setSelectedResources(prev => {
      const newSelection = {...prev};
      if (checked) {
        newSelection[row.resource_id] = row;
      } else {
        delete newSelection[row.resource_id];
      }
      return newSelection;
    });

    // Update email status in database
    // try {
    //   const payload = {
    //     api_key: auth?.api_key,
    //     resource_id: row.resource_id,
    //     is_email_send: checked ? 1 : 0,
    //   };

    //   const res = await AxiosService.post(
    //     UPDATE_RESOURCES_EMAIL_STATUS,
    //     payload
    //   );

    //   if (res.status === 200) {
    //     toast.success("Email status updated");
    //     handlePageChange(data.currentPage);
    //   }
    // } catch (error) {
    //   toast.error("Failed to update email status");
    // }
  };

  // Handle select all checkbox
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allSelected = {};
      data.rows.forEach(row => {
        allSelected[row.resource_id] = row;
      });
      setSelectedResources(allSelected);
    } else {
      setSelectedResources({});
    }
  };

  // Open email dialog
  const handleOpenEmailDialog = () => {
    setEmailDialogOpen(true);
  };

  // Close email dialog
  const handleCloseEmailDialog = () => {
    setEmailDialogOpen(false);
    setEmailInput("");
    setEmailList([]);
  };

  // Add email to list
  const handleAddEmail = () => {
    if (emailInput && isValidEmail(emailInput)) {
      // Check if email already exists
      if (!emailList.includes(emailInput)) {
        setEmailList([...emailList, emailInput]);
        setEmailInput("");
      } else {
        toast.error("This email has already been added");
      }
    }
  };

  // Remove email from list
  const handleRemoveEmail = (emailToRemove) => {
    setEmailList(emailList.filter(email => email !== emailToRemove));
  };

  // Validate email format
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle key press in email input
  const handleEmailKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddEmail();
    }
  };


  const handleSendEmails = async () => {
  if (emailList.length === 0) {
    toast.error("Please add at least one email address");
    return;
  }

  console.log(selectedResources);

  // Get all selected resource IDs
  const selectedResourceIds = Object.keys(selectedResources);

  // Collect company name, description, and images for each selected resource
  const resourcesData = [];

  Object.values(selectedResources).forEach(resource => {
    const images = [];

    if (resource.image_path_urls && Array.isArray(resource.image_path_urls)) {
      resource.image_path_urls.forEach(url => {
        const fullUrl = url.startsWith("http") ? url : `${url}`;
        images.push(fullUrl);
      });
    } else if (resource.image_path) {
      const fullUrl = resource.image_path.startsWith("http") ? resource.image_path : `${resource.image_path}`;
      images.push(fullUrl);
    }

    resourcesData.push({
      company_name: resource.comp_name || "Unknown Company",
      description: resource.description || "No description provided",
      images,
    });
  });

  if (selectedResourceIds.length === 0) {
    toast.error("Please select at least one resource");
    return;
  }

  if (resourcesData.every(r => r.images.length === 0)) {
    toast.error("No images found in selected resources");
    return;
  }

  setSendingEmail(true);

  try {
    const payload = {
      api_key: auth?.api_key,
      resource_ids: selectedResourceIds,
      emails: emailList,
      resources: resourcesData, // 👈 send full resource info (company, desc, images)
    };

    console.log("Sending payload:", payload);

    const res = await AxiosService.post(SEND_RESOURCES_EMAIL, payload);

    if (res.status === 200) {
      toast.success(`Email sent to ${emailList.length} recipients with company details & images`);

      // Refresh the data
      handlePageChange(data.currentPage);

      // Close dialog
      handleCloseEmailDialog();
    }
  } catch (error) {
    console.error("Error sending email:", error);
    toast.error("Failed to send email. Please try again.");
  } finally {
    setSendingEmail(false);
  }
};


  // Send emails with selected images
// const handleSendEmails = async () => {
//   if (emailList.length === 0) {
//     toast.error("Please add at least one email address");
//     return;
//   }

//   console.log(selectedResources)

//   // Get all selected resource IDs
//   const selectedResourceIds = Object.keys(selectedResources);
  
//   // Collect all image URLs from all selected resources into a single array
//   const allImageUrls = [];
  
//   Object.values(selectedResources).forEach(resource => {
//     if (resource.image_path_urls && Array.isArray(resource.image_path_urls)) {
//       // If image_path_urls is an array, add all URLs
//       resource.image_path_urls.forEach(url => {
//         const fullUrl = url.startsWith("http") ? url : `${url}`;
//         allImageUrls.push(fullUrl);
//       });
//     } else if (resource.image_path) {
//       // Fallback to single image_path if image_path_urls doesn't exist
//       const fullUrl = resource.image_path.startsWith("http") ? resource.image_path : `${resource.image_path}`;
//       allImageUrls.push(fullUrl);
//     }
//   });

//   if (selectedResourceIds.length === 0) {
//     toast.error("Please select at least one resource");
//     return;
//   }

//   if (allImageUrls.length === 0) {
//     toast.error("No images found in selected resources");
//     return;
//   }

//   setSendingEmail(true);
  
//   try {
//     const payload = {
//       api_key: auth?.api_key,
//       resource_ids: selectedResourceIds,
//       emails: emailList,
//       image_urls: allImageUrls, // Send all image URLs as a single array
//     };

//     console.log("Sending payload:", payload);

//     const res = await AxiosService.post(SEND_RESOURCES_EMAIL, payload);

//     if (res.status === 200) {
//       toast.success(`Email sent to ${emailList.length} recipients with ${allImageUrls.length} images`);
      
//       // Update email status for all selected resources
//       // const updatePromises = selectedResourceIds.map(resourceId => 
//       //   AxiosService.post(UPDATE_RESOURCES_EMAIL_STATUS, {
//       //     api_key: auth?.api_key,
//       //     resource_id: resourceId,
//       //     is_email_send: 1,
//       //   })
//       // );
      
//       //await Promise.all(updatePromises);
      
//       // Refresh the data
//       handlePageChange(data.currentPage);
      
//       // Close dialog
//       handleCloseEmailDialog();
//     }
//   } catch (error) {
//     console.error("Error sending email:", error);
//     toast.error("Failed to send email. Please try again.");
//   } finally {
//     setSendingEmail(false);
//   }
// };

  const formatDataForCsv = async (data) => {
    const headers = [
      { label: "ID", key: "resource_id" },
      { label: "Image Url", key: "image" },
      { label: "Employee", key: "emp_name" },
      { label: "Company", key: "comp_name" },
      { label: "Description", key: "description" },
      { label: "Email Status", key: "is_email_send" },
      { label: "Created", key: "created" },
    ];

    const rows = Array.isArray(data)
      ? data.map((item) => ({
          resource_id: item.resource_id,
          image: item.image_path_urls,
          emp_name: item.emp_name,
          comp_name: item.comp_name,
          description: item.description,
          is_email_send: item.email_send_status,
          created: new Date(item.created).toLocaleDateString(),
        }))
      : [];

    const isDownloadable = rows.length > 0;

    return { headers, rows, isDownloadable };
  };

  const getAllResources = async (payload) => {
    try {
      const { currentPage, ...payloadData } = payload;
      setLoading(true);
      const res = await AxiosServiceLoaderless.post(GET_ALL_RESOURCES, payloadData);
      if (res.status === 200) {
        setData((prev) => ({
          ...prev,
          rows: res.data.response || [],
          nextOffset: res.data.next_offset || 0,
          lastOffset: res.data.last_offset || 0,
          totalPages: res.data.total_records
            ? Math.ceil(parseInt(res.data.total_records) / parseInt(data.limit))
            : 0,
          currentPage: currentPage,
          totalRecords: res.data.total_records || 0,
        }));
        let updatedFields = fields.map((field) => {
          if (field.name === "comp_id") {
            field.options = res.data.complist;
          }
          if (field.name === "emp_id") {
            field.options = res.data.emplist;
          }
          return field;
        });
        // make download button visible, if total_records > 0
        if (res?.data?.total_records && res?.data?.total_records > 0) {
          setCsvData((prev) => ({ ...prev, isDownloadable: true }));
        } else {
          setCsvData((prev) => ({ ...prev, isDownloadable: false }));
        }
        setFields((prev) => updatedFields);
      }
    } catch (error) {
      console.log("Error:", error);
      setData((prev) => ({
        ...prev,
        rows: [],
        nextOffset: 0,
        lastOffset: 0,
        totalPages: 0,
        currentPage: payload.currentPage,
        limit: limit,
      }));
      setCsvData({ headers: [], data: [], isDownloadable: false });
    } finally {
      setLoading(false); // Set loading state to false after fetching data
    }
  };

  const handleSearch = (values) => {
    const data = {
      api_key: auth?.api_key,
      from: values?.from,
      to: values?.to,
      resource_id: values?.resource_id,
      emp_id: values?.emp_id,
      comp_id: values?.comp_id,
      is_email_send: values?.is_email_send,
      offset: 0,
      limit: limit,
      currentPage: 1,
    };
    // manage search fields in state
    setSearchFields(values);
    getAllResources(data);
  };

  const handlePageChange = (pageNo) => {
    let payload = {
      api_key: auth?.api_key,
      limit: data.limit,
      offset: (pageNo - 1) * data.limit,
      currentPage: pageNo,
    };
    if (searchFields && Object.keys(searchFields)) {
      // if search fields are filled then update payload for pagination
      payload = { ...payload, ...searchFields };
    }
    getAllResources(payload);
  };

  const handleImageClick = (imgUrl) => {
    setSelectedImage(imgUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };

  const handleCsv = async () => {
    try {
      let payloadData = {
        api_key: auth?.api_key,
        offset: 0,
        limit: data.totalRecords,
      };

      if (searchFields && Object.keys(searchFields)) {
        // add search fields to filter data for csv
        payloadData = { ...payloadData, ...searchFields };
      }

      const res = await AxiosServiceLoaderless.post(GET_ALL_RESOURCES, payloadData);

      if (res.status === 200) {
        const { headers, rows, isDownloadable } = await formatDataForCsv(
          res.data.response || []
        );
        setCsvData({ headers, data: rows, isDownloadable: isDownloadable });
        setTimeout(() => {
          csvLink.current.link.click();
        }, 700);
      }
    } catch (error) {
      console.log("Error::", error);
      setCsvData({ headers: [], data: [], isDownloadable: false });
    }
  };

  useEffect(() => {
    const payload = {
      api_key: auth?.api_key,
      limit: data.limit,
      offset: data.nextOffset,
      currentPage: 1,
    };
    getAllResources(payload);
  }, []);

  return (
    <Paper className={classes.root}>
      <div className={classes.title}>
        <Typography variant="h4" id="tableTitle">
          Resources Manager
        </Typography>
      </div>
      <SearchForm
        fields={fields}
        onSubmit={handleSearch}
        handleCsv={handleCsv}
        isDownloadable={csvData.isDownloadable}
      />
      
      {/* Send Email Button - Always visible but disabled when no selection */}
      <Box className={searchClasses.sendEmailButtonContainer}>
        <Typography className={searchClasses.selectedCount}>
          {Object.keys(selectedResources).length} item(s) selected
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          className={classes.sendEmailButton}
          onClick={handleOpenEmailDialog}
          disabled={Object.keys(selectedResources).length === 0}
          style={Object.keys(selectedResources).length === 0 ? { opacity: 0.6, cursor: 'not-allowed' } : {}}
        >
          Send Email
        </Button>
      </Box>
      
      <Box className={classes.subroot}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                <Checkbox
                  indeterminate={
                    Object.keys(selectedResources).length > 0 && 
                    Object.keys(selectedResources).length < data.rows.length
                  }
                  checked={Object.keys(selectedResources).length === data.rows.length && data.rows.length > 0}
                  onChange={handleSelectAll}
                  color="primary"
                />
                Select All
              </TableCell>
              <TableCell>ID</TableCell>
              <TableCell>Image</TableCell>
              <TableCell>Employee</TableCell>
              <TableCell>Company</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Email Status</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={8} className={classes.loadingCell}>
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {data?.rows?.length < 1 && (
                  <TableRow>
                    <TableCell colSpan={8} className={classes.loadingCell}>
                      <Typography variant="h6">No Record Found</Typography>
                    </TableCell>
                  </TableRow>
                )}
                {data?.rows?.map((row, index) => (
                  <TableRow key={row.resource_id}>
                    <TableCell>
                      <Checkbox
                        checked={!!selectedResources[row.resource_id]}
                        onChange={(e) =>
                          handleCheckboxChange(row, e.target.checked)
                        }
                        color="primary"
                      />
                    </TableCell>
                    <TableCell>{row.resource_id}</TableCell>
                    <TableCell>
                      <Box sx={{ cursor: "pointer" }}>
                        <Avatar
                          alt={row.name}
                          src={row.image_path?.startsWith("http") ? row.image_path : `${row.image_path}`}
                          style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                          onClick={() => handleImageClick(row.image_path)}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>{row.emp_name}</TableCell>
                    <TableCell>{row.comp_name}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>{row.email_send_status}</TableCell>
                    <TableCell>{row.created}</TableCell>
                  </TableRow>
                ))}
              </>
            )}
          </TableBody>
        </Table>
        
        {/* Email Dialog */}
        <Dialog open={emailDialogOpen} onClose={handleCloseEmailDialog} maxWidth="sm" fullWidth>
          <DialogTitle>Send Selected Images via Email</DialogTitle>
          <DialogContent>
            <Typography variant="body2" gutterBottom>
              Selected images: {Object.keys(selectedResources).length}
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              label="Email addresses"
              type="email"
              fullWidth
              variant="outlined"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
              onKeyPress={handleEmailKeyPress}
              helperText="Press Enter or comma to add multiple emails"
              placeholder="Enter email and press Enter to add"
            />
            <Box mt={2}>
              {emailList.map((email, index) => (
                <Chip
                  key={index}
                  label={email}
                  onDelete={() => handleRemoveEmail(email)}
                  className={searchClasses.emailChip}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEmailDialog} color="primary">
              Cancel
            </Button>
            <Button 
              onClick={handleSendEmails} 
              color="primary" 
              variant="contained"
              disabled={sendingEmail || emailList.length === 0}
            >
              {sendingEmail ? <CircularProgress size={24} /> : "Send Email"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Modal for bigger image */}
        {selectedImage && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
            onClick={closeModal}
          >
            <img
              src={selectedImage}
              alt="Large preview"
              style={{
                width: "45vw",            // 80% of viewport width
                height: "80vh",           // 80% of viewport height
                objectFit: "cover",
                borderRadius: "8px",
                background: "#fff"
              }}
            />
          </div>
        )}
      </Box>
      <PaginationFooter
        currentPage={data.currentPage}
        totalPages={data.totalPages}
        onPageChange={handlePageChange}
      />
      <CSVLink
        data={csvData.data || data.rows}
        headers={csvData.headers}
        filename={`resources_${new Date().toISOString()}.csv`}
        className="hidden"
        ref={csvLink}
      ></CSVLink>
    </Paper>
  );
};

export default withStyles(styles)(ActiveResources);